import React from 'react';
import qs from 'qs';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchGenericStats } from 'Store/stats/actions';
import { getGenericStats } from 'Store/reducers';

import PrettyJson from 'Components/PrettyJson';

class AdminPrettyJson extends React.Component {
  componentDidMount() {
    this.fetchJson();
  }

  fetchJson() {
    const { location } = this.props;
    const { endpoint } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (endpoint) this.props.fetchGenericStats(endpoint);
  }

  render() {
    const { location } = this.props;
    const { endpoint } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (!endpoint) return 'oy';
    return (
      <main className="Page__content">
        <PrettyJson endpoint={endpoint} stats={this.props.stats} />
      </main>
    );
  }
}

const mapStateToProps = (state, { location }) => {
  const { endpoint } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  return {
    stats: getGenericStats(state, endpoint),
  };
};

export default withRouter(
  connect(mapStateToProps, { fetchGenericStats })(AdminPrettyJson)
);
